import { Fragment, memo, useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import ReactJsonView from "@microlink/react-json-view";

import { Icon } from "design-react-kit";

import "react-pdf/dist/esm/Page/AnnotationLayer.css";

function PDFSidebar({
  files,
  setF24PageNumber,
  setSelectedFileHandler,
  applyCost,
  isPageValid,
  setIsVerified,
}) {
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [selectedJSON, setSelectedJSON] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [pages, setPages] = useState(1);

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const onDocumentLoad = ({ numPages }) => {
    setPages(numPages);
  };

  useEffect(() => {
    if (files !== null && files !== undefined) {
      const file = files[0];
      const fileName = file.fileName !== undefined ? file.fileName : file.name;
      fileName?.endsWith(".json")
        ? setSelectedJSON(JSON.parse(atob(file.fileContent)))
        : setSelectedPDF(file.fileContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files]);

  useEffect(() => {
    setTimeout(() => {
      const previewElements = document.querySelectorAll(".preview");
      previewElements[0]?.classList.add("active-pdf");
    }, 1000);
  }, [files]);

  const handlePDFSelection = (e, pdfUrl) => {
    if (e.target.classList.contains("active-pdf")) return;
    const previewElements = document.querySelectorAll(".preview");
    previewElements.forEach((el) => el.classList.remove("active-pdf"));
    e.target.closest(".preview").classList.add("active-pdf");
    setPageNumber(1);
    if (setF24PageNumber !== undefined) {
      setF24PageNumber(1);
    }
    setSelectedPDF(pdfUrl);
    setSelectedJSON(null);
  };

  const handleJSONSelection = (e, jsonContent) => {
    if (e.target.classList.contains("active-pdf")) return;
    const previewElements = document.querySelectorAll(".preview");
    previewElements.forEach((el) => el.classList.remove("active-pdf"));
    e.target.closest(".preview").classList.add("active-pdf");
    setPageNumber(1);
    if (setF24PageNumber !== undefined) {
      setF24PageNumber(1);
    }
    setSelectedJSON(JSON.parse(atob(jsonContent)));
    setSelectedPDF(null);
  };

  return (
    <div className="sidebar">
      <ul>
        <span className="total-docs text-center">Tot. Docs {files.length}</span>
        {files.map((file, i) => {
          const fileName =
            file.fileName !== undefined ? file.fileName : file.name;

          const isInvalid =
            file.isValid !== undefined &&
            file.isValid !== null &&
            !file.isValid;

          return !fileName?.endsWith(".json") ? (
            <div key={fileName}>
              <li
                className="preview"
                title={fileName}
                data-doc={i + 1}
                key={fileName}
                onClick={(e) => {
                  handlePDFSelection(e, file.fileContent, file.applyCost);
                  if (setSelectedFileHandler !== undefined) {
                    setSelectedFileHandler(file);
                    setIsVerified(file.isValid);
                  }
                }}
                data-error={isInvalid}
              >
                <Document file={{ data: atob(file.fileContent) }}>
                  <Page pageNumber={1} renderTextLayer={false} />
                </Document>
              </li>
            </div>
          ) : (
            <div key={file.name}>
              <li
                className="preview"
                title={fileName}
                data-doc={i + 1}
                key={file?.name}
                onClick={(e) => {
                  handleJSONSelection(e, file.fileContent, file.applyCost);
                  if (setSelectedFileHandler !== undefined) {
                    setSelectedFileHandler(file);
                    setIsVerified(file.isValid);
                  }
                }}
                data-error={isInvalid}
              >
                <img src="./Json_thumbnail.PNG" alt="JSON thumbnail" />
              </li>
            </div>
          );
        })}
      </ul>
      {selectedPDF && (
        <div className="pdf">
          <Fragment>
            {applyCost !== null && applyCost !== undefined && (
              <p className="d-flex justify-content-center">
                Apply cost: {applyCost ? "True" : "False"}
              </p>
            )}
            {pages > 1 && (
              <div className="mb-4">
                {pageNumber > 1 && (
                  <Icon
                    id="prev-page"
                    icon="it-chevron-left"
                    color="info"
                    role="button"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      setPageNumber((prevState) => prevState - 1);
                      if (setF24PageNumber !== undefined) {
                        setF24PageNumber((prevState) => prevState - 1);
                      }
                    }}
                  />
                )}
                <span>
                  Pagina {pageNumber} of {pages}
                </span>
                {pageNumber < pages && (
                  <Icon
                    id="next-page"
                    icon="it-chevron-right"
                    color="info"
                    role="button"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      setPageNumber((prevState) => prevState + 1);
                      if (setF24PageNumber !== undefined) {
                        setF24PageNumber((prevState) => prevState + 1);
                      }
                    }}
                  />
                )}
              </div>
            )}
            <div data-error={isPageValid !== undefined && !isPageValid}>
              <Document
                file={{ data: atob(selectedPDF) }}
                onLoadSuccess={onDocumentLoad}
              >
                <Page pageNumber={pageNumber} renderTextLayer={false} />
              </Document>
            </div>
            {pages > 1 && (
              <div>
                {pageNumber > 1 && (
                  <Icon
                    id="prev-page"
                    icon="it-chevron-left"
                    color="info"
                    role="button"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      setPageNumber((prevState) => prevState - 1);
                      if (setF24PageNumber !== undefined) {
                        setF24PageNumber((prevState) => prevState - 1);
                      }
                    }}
                  />
                )}
                <span>
                  Pagina {pageNumber} of {pages}
                </span>
                {pageNumber < pages && (
                  <Icon
                    id="next-page"
                    icon="it-chevron-right"
                    color="info"
                    role="button"
                    onClick={() => {
                      window.scrollTo(0, 0);
                      setPageNumber((prevState) => prevState + 1);
                      if (setF24PageNumber !== undefined) {
                        setF24PageNumber((prevState) => prevState + 1);
                      }
                    }}
                  />
                )}
              </div>
            )}
          </Fragment>
        </div>
      )}
      {selectedJSON && (
        <div className="json">
          <ReactJsonView src={selectedJSON} />
        </div>
      )}
    </div>
  );
}

export default memo(PDFSidebar);
